import { useEffect, useState } from 'react';
import { getSonataSession } from 'sonata-static-storage/lib/helpers/session.helpers';

import { DoohReport } from '@/components/doohReport';
import { AggregatedReport, FootfallReport } from '@/components/driveToStore';
import { useParams } from '@/router';
import { getSharedReportSession } from '@/services/sharedReport.service';

import type { SharedReport } from 'sonata-static-storage/lib/schemas/report/sharedReport.schema';

export default function SharedReportPage() {
  const { sharedReportId } = useParams('/sharedReport/:sharedReportId/report');
  const [report, setReport] = useState<SharedReport<string> | null>(null);

  useEffect(() => {
    // The access modal set the sonata session in the cookie before this full-page
    // reload, so it is available here to authorize the report fetch.
    getSharedReportSession(sharedReportId, getSonataSession()).then(setReport);
  }, [sharedReportId]);

  if (!report) {
    return null;
  }

  // report.user is the owner's userId; the shared session's cookie user is the share
  // system user, so the report data must be fetched with the owner's id.
  const entityId = report.campaignIds.map(String).join(',');
  const userId = String(report.user);

  if (report.type === 'singleDooh') {
    return <DoohReport lineItemId={entityId} userId={userId} />;
  }

  if (report.type === 'singleDriveToStore' && report.pois?.[0] != null) {
    return (
      <FootfallReport
        activePoiId={String(report.pois[0])}
        entityId={entityId}
        entityType="lineItem"
        sharedReportFullAccess={!!report.fullAccess}
        userId={userId}
      />
    );
  }

  return (
    <AggregatedReport
      entityId={entityId}
      entityType="lineItem"
      sharedReportFullAccess={!!report.fullAccess}
      userId={userId}
    />
  );
}
